/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
          fixedNav();
          menuMobile.showAndClose();
          subMenu.hoverMe();
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
          breakTheBusiness();
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
          //findMyNumbers();
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);


    function fixedNav() {
        var header = $('#masthead'),
            fixerClass = $('.fixed');


        //caches a jQuery object containing the header element

        $(window).scroll(function() {
            var scroll = $(window).scrollTop();

            if (scroll > 90 && scroll < 250) {
                header.addClass("noheight");
            }
            else {
                header.removeClass("noheight");
            }

            if (scroll >= 250) {
                header.addClass("fixed");
            } else {
                header.removeClass("fixed");
            }
        });

    }

    /****************************************
     Werkzeuge/Nav find first digits
     ****************************************/
    function findMyNumbers() {
        var strings = $('.post_content .entry-date');
        $('.post_content .entry-date').html(function (index, html) {
            return '<span class="uppertitle">' + html.slice(0, 3) + '</span>' + html.slice(3);
        });
    }

    /****************************************
     *ADD br to long Box
    ****************************************/
    function breakTheBusiness() {
        var aTags = document.querySelectorAll(".titleholder h3");
        var searchText = "Geschäftsmodell-innovation";
        var found;

        for (var i = 0; i < aTags.length; i++) {
            if (aTags[i].textContent == searchText) {
                found = aTags[i];
                var position = searchText.indexOf("-");
                var textOfString = found.innerText;
                var b = "-<br>";
                var output = [textOfString.slice(0, position), b, textOfString.slice(position + 1)].join('');
                found.innerHTML = output;
                break;
            }
        }
    }


})(jQuery); // Fully reference jQuery after this point.
